import React from 'react';
import { fetchSpecialty } from '../services/options_service';
import InputSelectAsync from './InputSelectAsync';

const SpecialtyInputAsync = ({ placeholderOption, ...props }) => (
  <InputSelectAsync
    defaultOptions
    label="Especialidade:"
    name="specialty"
    placeholder="Especialidade"
    loadOptions={(search) => fetchSpecialty({search})}
    getOptionLabel={(d) => d.name}
    getOptionValue={(d) => d.id}
    {...props}
  />
);

export default SpecialtyInputAsync;
